<template>
    <div
        :class="[
            'block',
            'text-block',
            layout.layout ||(layout.settings && layout.settings.layout),
            {
                columns: layout.columns || (layout.settings && layout.settings.columns)
            }
        ]">
        <div class="baseline">
            <!-- <SplitText
                :data="layout.baseline"
                class="baseline-sizer text"
            /> -->
            <div class="baseline-sizer text" v-html="layout.baseline"></div>
        </div>
        <div
            class="description text"
            v-if="layout.columns || (layout.settings && layout.settings.columns)"
        >
            <!-- <SplitText
                :data="layout.description"
            /> -->
            <p v-html="layout.description"></p>
            <template v-if="(layout.hascta || (layout.settings && layout.settings.hascta))">
                <Cta
                    v-if="!layout.call_to_action.scrolltarget"
                    :type="'router-link'"
                    :to="$trl({
                        name: layout.call_to_action.link
                    })"
                    class="link"
                >   {{layout.call_to_action.caption}}
                </Cta>
                <Cta
                    v-else
                    :type="'button'"
                    @click.native="scrollTo(layout.call_to_action.target)"
                    class="button-link link"
                >   {{layout.call_to_action.caption}}
                </Cta>
            </template>
        </div>
    </div>
</template>

<script>
// import SplitText from '@/components/SplitText'
import Cta from '@/components/Cta'
export default {
    components: {
        // SplitText,
        Cta
    },
    props: {
        layout: {
            type: Object,
            default() {}
        }
    },
    methods: {
        scrollTo(target) {
            const d = this.$el.parentNode.children[target].offsetTop
            window.scrollTo({
                top: d,
                behavior: 'smooth'
            })
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.baseline-sizer
    // padding-right: 23%
.text-block
    display: flex
    @media print
        display: block
        // page-break-inside: avoid
        // break-inside: avoid
    @include media-breakpoint-down($hd)
        flex-direction: column
    &+.text-block
        .baseline-sizer
            padding-right: 10%
    &+.columns
        .baseline-sizer
            padding-right: 0%


.baseline
    flex: 1
    @include media-breakpoint-down($hd)
        flex-basis: auto
    .columns &
        flex: .7
        @include media-breakpoint-down($hd)
            flex-basis: auto
    .equal &
        flex: .5
        @include media-breakpoint-down($hd)
            flex-basis: auto
.description
    flex: 1
    @include media-breakpoint-down($hd)
        margin-top: 6.25%
        flex-basis: auto
    .columns &
        flex: .3
        @include media-breakpoint-down($hd)
            flex-basis: auto
    .equal &
        margin-left: 12.5%
        flex: .5
        @include media-breakpoint-down($hd)
            margin-left: 0
            flex-basis: auto
.cta
    margin-top: 8%
    border: 1px solid #e5e5e5
button.cta
    @media print
        display: none
a.cta
    @media print
        position: relative
        overflow: visible
        border: none
        &:after
            content: "https://www.soletanche-bachy.com" attr(href)
            font-size: 12px
            font-weight: normal
.button-link
    /deep/ svg
        transform: rotate(90deg)
</style>
